import { Context } from '@nuxt/types'

/** This method is created because it's used in the store getter function and it's impossible to
 * mock store getters, so this function is created so it can be mocked and the unit tests are not failing
 */
export const getCookies = (props: { context: Context; cookieName: string }) => {
  return props.context.$cookies.get(props.cookieName)
}
